import { Skeleton as MUISkeleton, SkeletonProps as MUISkeletonProps } from '@mui/material';

export interface SkeletonProps extends MUISkeletonProps {}

export const Skeleton = MUISkeleton;
